var constants = require('../constants');

var ClearResponse = (function() {

    var _clearCurrentResponse = function() {
        return {
            type: constants.CLEAR_CURRRENT_RESPONSE
        };
    }

    return {
        clearCurrentResponse: _clearCurrentResponse
    }
})();

module.exports = ClearResponse;


// WEBPACK FOOTER //
// ./src/common/modules/responses/actions/clear-current-response.js